import { render, staticRenderFns } from "./SingleVariant.vue?vue&type=template&id=7560dafc&"
import script from "./SingleVariant.vue?vue&type=script&setup=true&lang=js&"
export * from "./SingleVariant.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports